import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
// State Import
import { useEntitlementList } from "../../state/entitlementListState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { TableFilterBar } from "../../components/TableFilterBar";
import { EntitlementTable } from "./EntitlementTable1";

// MUI Imports
import Typography from "@mui/material/Typography";

export function EntitlementList({ type }) {
  // List of staff
  const [entitlementStaffList, setEntitlementStaffList] = useState({
    filter: {},
    staff: [],
    paging: {},
  });

  // Entitlement list filter defaults
  const [filter, setFilter] = useUrlFilterState(
    {
      search: "",
      branchId: "",
      type: type,
      page: 1,
      pageSize: 25,
    },
    { exclude: ["type", "pageSize", "branchId"] },
  );

  // Fetch list of staff
  const { isError, data, error, isFetching, isSuccess } =
    useEntitlementList(filter);

  // Success Function
  const successFunc = () => {
    setEntitlementStaffList(data.data.data.data.list);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <GenericListHeader heading={`Entitlement ${type}`} />
      <TableFilterBar
        filter={filter}
        setFilter={setFilter}
        invalidateQuery={["entitlementStaff"]}
      />
      {isError && <Typography>Error: {error.message}</Typography>}
      <EntitlementTable
        data={entitlementStaffList}
        loading={isFetching}
        filter={filter}
        setFilter={setFilter}
        type={type}
      />
    </>
  );
}
